module.exports = __webpack_public_path__ + "media/images/locale-0b04a34822133e1dac263285831603dc.png";